import { useTranslation } from "react-i18next";
import { Tab } from "semantic-ui-react";

import { KEYLOCKER_COMMUNICATION_STATUSES } from "models";
import { Content } from "modules/AppointmentDetails/components/KeylockerCommunicationLog/components";

import type { Appointment, KeyLockerCommunication } from "models";
import type { ReactNode } from "react";

type CommunicationsProps = {
  appointment: Appointment;
  keylocker_communications: KeyLockerCommunication[];
};

type CommunicationPane = {
  menuItem: string;
  render: () => ReactNode;
};

export const Communications = ({ appointment, keylocker_communications }: CommunicationsProps) => {
  const { t } = useTranslation();
  const panes: CommunicationPane[] = [];

  const getMenuItem = (status: number) => {
    if (status === KEYLOCKER_COMMUNICATION_STATUSES.PickUpPINSent) return t("v8_pick_up_key", "Pick up key");

    return t("v8_drop_key", "Drop key");
  };

  keylocker_communications
    .sort((comm1, comm2) => comm1.created_on.localeCompare(comm2.created_on))
    .forEach(comm => {
      panes.push({
        menuItem: getMenuItem(comm.status),
        render: () => <Content appointment={appointment} comm={comm} />
      });
    });

  return panes.length > 0 ? <Tab menu={{ secondary: true }} panes={panes} /> : null;
};
